import React, { Component } from 'react';
import { connect } from 'react-redux';
import { observer, inject } from "mobx-react";
import { toJS } from 'mobx';
import { Editor } from '@tinymce/tinymce-react';



class CommentEditor extends Component {
  constructor(props) {
    super(props);
    this.state={
      value:""
    }
  }
  componentDidUpdate() {
    const val=toJS(this.props.linker.value);
    if(val !== this.state.value) {
      console.log("did mount", val);
      this.setState({value: val});
    }
  }
  getEditorCss() {
    return this.props.commentsStore.editor_css || "https://develop.myanimeshelf.com/scss2css.php?file=/eva2/site_templates/mas2/css/style.scss&type=mas2";
  }
  render() {
    const modules= {
      toolbar: ['bold', 'italic', 'underline', 'strike', {'list': 'ordered'}, {'list': 'bullet'},'spoilerHandler'],
    };
    return (
      <div>
        <Editor
         key={this.props.small?'small_editor':'big_editor'}
         initialValue={this.state.value}
         tinymceScriptSrc={"https://myanimeshelf.com/app/tinymce/tinymce.min.js"}
         init={{
           browser_spellcheck : true,
           content_css: this.getEditorCss(),
           body_class: "mas2",
           valid_elements: "div[style|class=mas-spoiler|mas-spoiler-title|mas-spoiler-body|mas-root|mceNonEditable|mceEditable],p[style|class=|text_size1|text_size2|text_size3|text_size4|text_size5|text_size6|text_size7|text_size8],strong,bold,i,em,span[class=|emo-smile|mceNonEditable|style],ol,ul,li,a[href|style|class|data-user-id],br",
           valid_classes: {
             div: "mas-spoiler mas-spoiler-title mas-spoiler-body mas-root mceNonEditable mceEditable text_size8",
             span: "emo-smile mceNonEditable",
             a: "mceNonEditable mas-mentoin",
             p: "text_size1 text_size2 text_size3 text_size4 text_size5 text_size6 text_size7 text_size8",
           },
           link_quicklink:false,
           init_instance_callback: (editor)=>{
             if(window.innerWidth > 768) {
               if(this.props.autofocus) {
                 editor.execCommand('mceFocus');
               }
             }
             editor.addShortcut("ctrl+13", "Отправить комментарий", (e)=>{
               if(this.props.onCtrlEnter) {
                 this.props.onCtrlEnter();
                 return false;
               }
             })
             editor.on('paste', (e)=>{
               e.preventDefault();
               e.stopPropagation();
               if(e.clipboardData.files.length) {
                 const fileUploaded = e.clipboardData.files[0];
                 if(fileUploaded.type.split("/")[0] == "image") {
                   const reader = new FileReader();
                   reader.onload = ()=>{
                     fileUploaded.preview = reader.result;
                     console.log(fileUploaded);
                     this.props.onFilePaste(fileUploaded);
                   };
                   reader.readAsDataURL(fileUploaded);
                 }
               }
             });
             editor.on('KeyDown', function (e) {
               console.log('e.keyCode',e.keyCode);
               if (e.keyCode == 40 || e.keyCode == 38) {
                 const pastBefore = e.keyCode == 38;
                 // let editor = tinyMCE.activeEditor
                 const dom = editor.dom;
                 let parentBlock = editor.selection.getSelectedBlocks()[0];
                 if(pastBefore) {
                   if (parentBlock.previousElementSibling) {
                     return true;
                   }
                 } else {
                   if (parentBlock.nextElementSibling) {
                     return true;
                   }
                 }
                 let parentNode=parentBlock;
                 while (true) {
                   if(parentNode.classList.contains("mce-content-body")) {
                     break;
                   }
                   if(parentNode.classList.contains("mas-root")) {
                     parentBlock=parentNode;
                     break;
                   }
                   parentNode=parentNode.parentNode;
                 }
                 if(parentNode.classList.contains("mas-root")) {
                   console.log('parentNode', {pp: parentNode});
                   if (!parentBlock.nextElementSibling && !pastBefore || pastBefore && !parentBlock.previousElementSibling) {
                     console.log('parentBlock', {par: dom});
                     const containerBlock = parentBlock.parentNode.nodeName == 'BODY' ? dom.getParent(parentBlock, dom.isBlock) : dom.getParent(parentBlock.parentNode, dom.isBlock)
                     let newBlock = editor.dom.create('p')
                     newBlock.innerHTML = '<br data-mce-bogus="1">';
                     if (pastBefore) {
                       dom.getRoot().prepend(newBlock);
                       // dom.insertBefore(newBlock, containerBlock)
                     } else {
                       dom.insertAfter(newBlock, containerBlock)
                     }
                     let rng = dom.createRng();
                     newBlock.normalize();
                     rng.setStart(newBlock, 0);
                     rng.setEnd(newBlock, 0);
                     editor.selection.setRng(rng);
                   }
                 }
               }
             });
           },
           mentions: {
               source: [
                   { name: 'Tyra Porcelli' },
                   { name: 'Brigid Reddish' },
                   { name: 'Ashely Buckler' },
                   { name: 'Teddy Whelan' }
               ]
           },
           forced_root_block: 'p',
           external_plugins: {
             spoiler: 'https://myanimeshelf.com/app/tinymce/spoiler_plugin.js?v=13',
             emosmiles: 'https://myanimeshelf.com/app/tinymce/emo_smiles.js?v=13',
             mention: 'https://myanimeshelf.com/app/tinymce/mention.js?v=16',
           },
           height: 200,
           menubar: false,
           block_formats: 'Обычный=p;Размер 1=text_size1;Размер 2=text_size2;Размер 3=text_size3;Размер 4=text_size4;Размер 5=text_size5;Размер 6=text_size6;Размер 7=text_size7;Размер 8=text_size8;',
           formats: {
             text_size1: {classes: 'text_size1', exact:true, block:'p'},
             text_size2: {classes: 'text_size2', exact:true, block:'p'},
             text_size3: {classes: 'text_size3', exact:true, block:'p'},
             text_size4: {classes: 'text_size4', exact:true, block:'p'},
             text_size5: {classes: 'text_size5', exact:true, block:'p'},
             text_size6: {classes: 'text_size6', exact:true, block:'p'},
             text_size7: {classes: 'text_size7', exact:true, block:'p'},
             text_size8: {classes: 'text_size8', exact:true, block:'p'},
           },
           contextmenu:false,
           language:"ru",
           placeholder:this.props.small?"Ваш комментарий":"Поле для вашего искрометного комментария",
           autoresize_bottom_margin:0,
           statusbar:false,
           plugins: [
             'spoiler autolink lists',
             'searchreplace code',
             'paste code textcolor noneditable emosmiles autoresize link autosave mention'
           ],
           quickbars_insert_toolbar:false,
           relative_urls: false,
           autosave_prefix: 'mas-autosave-comment',
           autosave_interval: '5s',
           toolbar: this.props.small?'':
             'undo redo | formatselect | emosmiles spoiler | bold italic underline strikethrough backcolor forecolor link | \
             alignleft aligncenter alignright | \
             bullist numlist | removeformat restoredraft'
         }}
         onEditorChange={(newValue)=>{ this.props.linker.value=newValue; }}
       />
        {/*
        <CKEditor
          editor={ClassicEditor}
          data="<p>Hello from CKEditor 5!</p>"
          config={{
            plugins: [ Essentials, Paragraph, Bold, Italic ],
            toolbar: [ 'bold', 'italic' ]
            // plugins: [InsertSpoilerPlugin],
            // toolbar: ['heading', '|', 'bold', 'italic', 'underline', 'link', 'numberedList', 'bulletedList'],
          }}
          onReady={(editor)=>{
              console.log( 'Editor is ready to use!', editor );
          }}
          onChange={(event,editor)=>{
              const data = editor.getData();
              console.log( { event, editor, data } );
          }}
          onBlur={(event,editor)=>{
              console.log( 'Blur.',editor );
          }}
          onFocus={(event,editor)=>{
              console.log( 'Focus.', editor);
          }}
        />


        <ReactQuill
          ref={(ref)=>{ console.log('ref',ref); }}
          onEditorChange={(ed1,ed2,ed3)=>{ console.log('EDITOR CHANGE',ed1,ed2,ed3); }}
          placeholder={"Поле для вашего искрометного комментария"}
          theme="snow"
          modules={modules}
          value={this.props.linker.value}
          onChange={(newValue)=>{
            this.props.linker.value=newValue;
            // this.props.valueLink.requestChange(newValue);
          }}
        />
        */}
        {/*
        <textarea value={this.props.valueLink.value} onChange={(e)=>{ this.props.valueLink.requestChange(e.target.value); }} className="w100" style={{height:100}}></textarea>
        */}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {

  }
}


export default inject("commentsStore")(observer(CommentEditor));